import React from 'react'
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useState } from 'react';

const Faqs = () => {

    const initialContentState = Array(6).fill(false); // Assuming you have 6 content blocks
    const [contentStates, setContentStates] = useState(initialContentState);

    const handleContentClick = (index) => {
        const newContentStates = contentStates.map((_, i) => i===index? !_ : _);
        //console.log(newContentStates);
        setContentStates(newContentStates);
    };

    const contentArray = [
        {
            "question": "Why did my cibil score drop",
            "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ab eveniet alias a tempore rem adipisci asperiores voluptas illum, sapiente at sed dolorem nulla inventore quaerat.",
        },
        {
            "question": "Why did my cibil score drop",
            "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ab eveniet alias a tempore rem adipisci asperiores voluptas illum, sapiente at sed dolorem nulla inventore quaerat.",
        },
        {
            "question": "Why did my cibil score drop",
            "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ab eveniet alias a tempore rem adipisci asperiores voluptas illum, sapiente at sed dolorem nulla inventore quaerat.",
        },
        {
            "question": "Why did my cibil score drop",
            "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ab eveniet alias a tempore rem adipisci asperiores voluptas illum, sapiente at sed dolorem nulla inventore quaerat.",
        },
        {
            "question": "Why did my cibil score drop",
            "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ab eveniet alias a tempore rem adipisci asperiores voluptas illum, sapiente at sed dolorem nulla inventore quaerat.",
        },
        {
            "question": "Why did my cibil score drop",
            "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Id ab eveniet alias a tempore rem adipisci asperiores voluptas illum, sapiente at sed dolorem nulla inventore quaerat.",
        },

    ];
    return (
        <div className='mb-10 max-lg:mt-20'>
            <p className='text-3xl md:text-4xl text-center mt-[10%] mb-[5%]'>Frequently asked <span className='text-primary'>Questions</span>
            </p>
            <div className='flex flex-col gap-3 w-full justify-center items-center'>
                <div className='flex flex-col gap-3 w-full justify-center items-center'>
                    {contentArray.map((content, index) => (
                        <div key={index} onClick={() => handleContentClick(index)} className='cursor-pointer md:w-[80%] lg:w-[80%] w-[90%] h-auto shadow-md hover:shadow-xl p-[2%] rounded-lg max-md:px-2'>
                            <div className='max-md:h-10 flex justify-between items-center max-md:px-2'>
                                <p>{content.question}</p>
                                {contentStates[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
                            </div>
                            {contentStates[index] && (
                                <p className='mt-2 max-md:px-2'>{content.answer}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Faqs;